import { NewTab, PageTab, PageTabAdv } from "../../../../components";
import GeneralDetails from "./CompanyProfileTabs/GeneralDetails";
import BillingAddress from "./CompanyProfileTabs/BillingAddress";
import InboxConfiguration from "./CompanyProfileTabs/InboxConfiguration";
import LocalInformation from "./CompanyProfileTabs/LocalInformation";
import Branding from "./CompanyProfileTabs/Branding";
import { useModuleAccess } from "../../../../hooks";
import { getItem } from "../../../../utils/localStorageUtils";
import ContactInformation from "./CompanyProfileTabs/ContactInformation";



const CompanyProfile = () => {
  const portal = getItem("portal");
   
  const DashboardMenus = [
    {
      title: "General Details",
      page: <GeneralDetails />,
      type: "main",
      id: "settings_companyprofile_generaldetails",
    },
    {
      title: "Branding",
      page: <Branding />,
      type: "main",
      id: "settings_companyprofile_branding",
    },
   {
      title: "Locale Information",
      page: <LocalInformation />,
      type: "main",
      id: "settings_companyprofile_localinformation",
    },
    {
      title: "Billing & Subscription    ",
      page: <BillingAddress />,
      type: "main",
      id: "settings_companyprofile_blllingsubscription",
    },
    {
      title: "Contact Information",
      page: <ContactInformation />,
      type: "main",
      id: "settings_companyprofile_contactinformation",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: DashboardMenus,
    parentId: "settings_companyprofile",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  return (
    <div className="h-screen! flex flex-1 mt-4 overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="company-profile"
      />
    </div>
  );
};

export default CompanyProfile;
